module.exports = __webpack_public_path__ + "static/media/009.341e0f48.jpg";